import { ModalPopup, Stack } from 'components';
import { DraftNoteForm } from 'modules/notes/notePopup/noteEdit/presets';
import { NoteFormValues } from 'modules/notes/notePopup/noteEdit/utils';
import { StatusesItem } from 'store/clients/clientsSlice';

import style from './noteModal.module.scss';

type Props = {
  open: boolean;
  handleClose: () => void;
  note: Partial<NoteFormValues> | undefined;
  status: StatusesItem['id'];
  clientId: string;
  clientName: string;
  prependedClientId: string;
  onSubmitSuccess?: () => void;
  onDeleteSuccess?: () => void;
  onOpenAiScribeDrawer?: () => void;
};

const NoteContent = ({
  status,
  clientId,
  clientName,
  prependedClientId,
  note,
  onSubmitSuccess,
  onDeleteSuccess,
  onOpenAiScribeDrawer
}: Omit<Props, 'open' | 'handleClose'>) => {
  return (
    <DraftNoteForm
      status={status}
      clientId={clientId}
      clientName={clientName}
      prependedClientId={prependedClientId}
      note={{
        noteType: note?.noteType ?? ''
      }}
      onSubmitSuccess={onSubmitSuccess}
      onDeleteSuccess={onDeleteSuccess}
      onOpenAiScribeDrawer={onOpenAiScribeDrawer}
    />
  );
};

const NoteModal = ({
  open,
  handleClose,
  note,
  status,
  clientId,
  clientName,
  prependedClientId,
  onOpenAiScribeDrawer
}: Props) => {
  return (
    <ModalPopup
      open={open}
      handleClose={handleClose}
      customClassInsideContainer={style.modal}
      customClassModalContentContainer={style.contentContainer}
    >
      <Stack display="flex" flexDirection="column" gap="20px" height="100%" width="100%">
        <p className={style.title}>Want to leave a note?</p>
        <Stack overflow="auto" px="1px" className={style.noteContent}>
          <NoteContent
            status={status}
            clientId={clientId}
            clientName={clientName}
            prependedClientId={prependedClientId}
            note={note}
            onSubmitSuccess={handleClose}
            onDeleteSuccess={handleClose}
            onOpenAiScribeDrawer={handleClose}
          />
        </Stack>
      </Stack>
    </ModalPopup>
  );
};

export default NoteModal;
